import React from 'react';
import cn from 'classnames';

const Disclaimer = ({ message, subline, className, ...rest }) => (
  <div className={cn('disclaimer', className)} {...rest}>
    <svg width={28} height={26} fill="none">
      <path
        d="M14 1.656c.104 0 .27.042.5.125.25.063.458.24.625.532l10.563 18.5c.104.187.177.385.218.593.063.188.094.386.094.594 0 .208-.031.417-.094.625a1.683 1.683 0 01-.218.531c-.105.167-.23.323-.375.469a2.65 2.65 0 01-.47.375 2.987 2.987 0 01-.593.25 1.968 1.968 0 01-.625.094H4.375c-.23 0-.448-.032-.656-.094a3.32 3.32 0 01-.563-.25 2.648 2.648 0 01-.469-.375 2.643 2.643 0 01-.374-.469 2.474 2.474 0 01-.25-.531A3.18 3.18 0 012 22c0-.208.02-.406.063-.594.062-.208.145-.406.25-.593l10.562-18.5c.167-.292.365-.47.594-.532.25-.083.427-.125.531-.125zm0-1.312c-.438 0-.865.114-1.281.344-.417.208-.75.53-1 .968L1.156 20.125c-.708 1.23-.708 2.458 0 3.688.73 1.229 1.802 1.843 3.219 1.843h19.25c1.417 0 2.48-.614 3.188-1.843.729-1.23.74-2.459.03-3.688L16.282 1.656a2.354 2.354 0 00-1-.968A2.628 2.628 0 0014 .344zm-.656 9.312h1.312v8h-1.312v-8zM15 20c0 .27-.104.51-.313.719A.936.936 0 0114 21c-.27 0-.51-.094-.719-.281A1.044 1.044 0 0113 20c0-.27.094-.5.281-.688A.988.988 0 0114 19c.27 0 .5.104.688.313A.89.89 0 0115 20z"
        fill="currentColor"
      />
    </svg>

    <div className="disclaimer-body">
      {message && <div className="disclaimer-text">{message}</div>}
      {subline && <div className="disclaimer-muted">{subline}</div>}
    </div>

    <style jsx>{`
      .disclaimer {
        background-color: #531e6d;
        border-radius: 4px;
        color: #fff;
        padding: 24px 32px;
        display: flex;
        margin-bottom: 32px;
      }

      .disclaimer-body {
        flex: 1;
        padding-top: 2px;
      }

      .disclaimer-text {
        font-weight: 800;
        font-size: 16px;
      }

      .disclaimer-muted {
        font-size: 15px;
        opacity: 0.8;
      }

      .disclaimer svg {
        margin-right: 20px;
      }
    `}</style>
  </div>
);

export default Disclaimer;
